import { createContext, useState } from "react";

export const ChatContext = createContext();

export function ChatProvider({children}){
    const [currentUser, setCurrentUser] = useState(null);
    const [currentSelectedChat, setCurrentSelectedChat] = useState(null)

    return (
        <ChatContext.Provider value={{currentUser, setCurrentUser, currentSelectedChat, setCurrentSelectedChat}}>
            {children}
        </ChatContext.Provider>
    )
}